/** Admin client-config types mirrored from Player-API `/v1/admin/client-config`. */

export type FrontendUiPolicy = {
  minVersion: string
  latestVersion: string
  forceUpdate: boolean
  iosUrl: string
  androidUrl: string
  webBuildId: string
  forceWebReload: boolean
}

export type BackendUiPolicy = {
  minBuildId: string
  forceReload: boolean
}

export type ClientConfigPolicy = {
  frontendUi: FrontendUiPolicy
  backendUi: BackendUiPolicy
}

export type ClientConfigAdminView = {
  policy: ClientConfigPolicy
  source: 'env' | 'override'
  updatedAt: string | null
}

export const EMPTY_POLICY: ClientConfigPolicy = {
  frontendUi: {
    minVersion: '0.0.0',
    latestVersion: '0.1.0',
    forceUpdate: false,
    iosUrl: '',
    androidUrl: '',
    webBuildId: '',
    forceWebReload: false,
  },
  backendUi: {
    minBuildId: '',
    forceReload: false,
  },
}

export const DEMO_CLIENT_CONFIG: ClientConfigAdminView = {
  policy: {
    ...EMPTY_POLICY,
    frontendUi: {
      ...EMPTY_POLICY.frontendUi,
      minVersion: '0.1.0',
      latestVersion: '0.1.0',
    },
  },
  source: 'env',
  updatedAt: null,
}
